import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="container">
      <div className="page-section animate-fade-in-up animate-stagger">
        <Contact />
      </div>
    </div>
  );
};

export default ContactPage;
